import React from 'react';
import { cn } from '@/lib/utils';
import helicopterSilhouetteIcon from '@/assets/helicopter-silhouette-icon.png';

interface HelicopterSilhouetteIconProps {
  className?: string;
  /** 
   * Visual tone for the icon:
   * - 'nav': dark icon for light backgrounds (brightness-0)
   * - 'inverse': white icon for dark/colored backgrounds (brightness-0 invert)
   */
  tone?: 'nav' | 'inverse';
  /** Whether the icon is in an active/selected state (affects opacity) */
  active?: boolean;
}

/**
 * Reusable helicopter silhouette icon component with optical scaling.
 * The PNG has internal padding, so we apply CSS transform scale to match
 * the visual weight of Lucide icons and the engine turbine icon.
 */
const HelicopterSilhouetteIcon: React.FC<HelicopterSilhouetteIconProps> = ({
  className = '',
  tone = 'nav',
  active = true,
}) => {
  return (
    <img
      src={helicopterSilhouetteIcon}
      alt=""
      className={cn(
        'object-contain flex-shrink-0',
        // Optical scaling + negative margin to match engine icon perceived size
        'transform scale-[2.2] origin-center -m-1',
        // Color treatment based on tone
        tone === 'inverse' 
          ? 'brightness-0 invert' 
          : cn('brightness-0 dark:invert', active ? 'opacity-90' : 'opacity-70'),
        className
      )}
    />
  );
};

export default HelicopterSilhouetteIcon;
